import * as React from 'react';
import Icon from './Icon';

const Close: React.FunctionComponent<{ color: string}> = ({ color }) => (
  <Icon height={18} width={18} viewBox={'0 0 143.40416 143.93334'} color={color}>
    <g
      transform="translate(0,-153.06663)"
      id="layer1">
      <path
        id="path826"
        d="M 0.83088,296.1543 C 0.20793,295.53187 0,294.96238 0,293.87864 v -1.44548 l 33.51237,-33.4954 c 18.4318,-18.42247 33.512365,-33.62537 33.512365,-33.78422 0,-0.15884 -15.080565,-15.42594 -33.512365,-33.92689 C 0.85817,158.44997 0,157.55571 0,156.30524 c 0,-2.27603 1.9707,-3.79588 3.94795,-3.04476 0.42151,0.16013 15.81444,15.37771 34.20651,33.81684 l 33.440143,33.52572 33.739867,-33.7494 c 32.09802,-32.10707 33.79836,-33.74938 34.94176,-33.74938 2.14405,0 3.63536,2.10251 2.89815,4.08595 -0.20058,0.53963 -14.84898,15.44286 -33.74447,34.33147 l -33.390041,33.37789 12.565448,12.7896 c 6.910997,7.03429 21.877103,22.07384 33.258023,33.42124 11.38092,11.34739 20.92089,21.06128 21.19994,21.58642 1.05795,1.99094 -0.47014,4.27273 -2.88168,4.30304 -1.17887,0.0148 -2.45704,-1.222 -34.84251,-33.71542 L 71.720354,229.55366 37.97523,263.26907 C 5.06804,296.1473 4.19821,296.98449 2.94594,296.98449 c -0.91209,0 -1.52491,-0.24054 -2.11506,-0.83019 z"
      />
    </g>
  </Icon>
)

export default Close;
